import * as bootstrap from "bootstrap";
const element = document.querySelector("#roadmapToast");

if (element) {
    const toast = new bootstrap.Toast(element, {
    });
    toast.show();
}

export default undefined;
